import * as Events from '@/constant/events'
import { Notification } from 'element-ui'
import Vue from 'vue'

let noticeVm = null

export default {
  // 小结单 保存并转办 逻辑处理
  '10001'(data, response) {
    Events.emit(Events.RECORD_ERROR_10001)
  },
  '-2001'(data, response) {
    if (response.config.url?.includes?.('crm-online-service-app/newImMessage/receive/ocsReceiveMessage')) {
      if (noticeVm) return
      const alertMessage = '检测到您已登录过其他账号，请刷新重新加载！'
      let tipInstance = new Vue({
        render: h => h('div', [h('div', { class: 'v-mb-10' }, alertMessage)])
      }).$mount()
      noticeVm = Notification({
        title: '警告',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        message: tipInstance?._vnode,
        iconClass: 'el-icon-warning',
        duration: 0,
        offset: 80,
        onClose: () => {
          if (noticeVm) {
            noticeVm.destroyElement()
            noticeVm = null
          }
          tipInstance?.$destroy?.()
          tipInstance = null
        }
      })
    }
  }
}
